export default {
    sampleState: "Aron is not Awesome", 
    mainInfo: [],
    mainDataStructure:[],
    endPoint: "",
    whenSuccessCallback:"",
    profileId:"",
    showPopup:"", // use in selecting multiple data in selectable.vue 
    currentDataStructure:[],
    currentMainInfo:[],
    childDataMarker: "main", //use for search in advance table search.vue. this is set in getData under advance_table.vue
}
 